import { render } from "./App.vue?vue&type=template&id=d09b6736"
const script = {}

import "./App.vue?vue&type=style&index=0&id=d09b6736&lang=scss"
script.render = render

export default script